/**
 * Build metadata shown in the editor UI and attached to perf telemetry, so a bug
 * report can be tied to a build ("what version is each person on").
 *
 * The values are injected at start/build time by scripts/withBuildInfo.js as
 * REACT_APP_BUILD_* environment variables, which CRA inlines at compile time. This
 * file is static and tracked — it used to be regenerated on every run, which dirtied
 * a tracked file per developer and branch. The fallbacks apply under jest and any
 * direct `react-scripts` invocation that bypasses the wrapper.
 */
export const BUILD_INFO = {
  version: process.env.REACT_APP_BUILD_VERSION ?? '0.0.0',
  commit: process.env.REACT_APP_BUILD_COMMIT ?? 'dev',
  branch: process.env.REACT_APP_BUILD_BRANCH ?? '',
  builtAt: process.env.REACT_APP_BUILT_AT ?? '',
} as const;

/** Short label for the editor UI, e.g. "v1.4.0 · 9517406". */
export const BUILD_LABEL = `v${BUILD_INFO.version} · ${BUILD_INFO.commit}`;
